<template lang="pug">
  div#app
    div(
      v-if="loader.status",
      v-loading="loader.status",
      v-loading.fullscreen.lock="true",
    )
    el-container
      el-header.custom-header
        header-sicarf(
          @sair="sair",
          @goToMeusDados="goToMeusDados",
          @notificacoes="notificacoes",
          @modelo="toModelos",
          :imagemLogo="require('@/assets/logo-pa.png')",
          :usuario="usuario",
          :qtdNovasNotificacoes="perfilCredenciado ? qtdNotificacoes : ''",
          :modelo='perfilInterno',
          :isPA="isEstadoPA",
        )
      el-container
        el-aside(width="150px" v-if="showSideBar")
          SideMenu(v-if="perfilCredenciado" :menuOptions="menuOptionsCredenciado")
          SideMenu(v-else :menuOptions="menuOptions")
        el-main.main
          router-view
</template>

<script>
import { HeaderSicarf, SideMenu } from 'sicarf-components';
import { getToken, getUsuario, logout } from './store/auth';
import { listConversas } from '@/services/conversaService';
import { getProfilePicture } from '@/services/profile';
import { ROUTE_GROUPS } from '@/constants/constants';
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    HeaderSicarf,
    SideMenu,
  },
  data () {
    return {
      usuario: null,
      isEstadoPA: process.env.VUE_APP_ESTADO === 'PA',
      perfilCredenciado: false,
      perfilInterno: false,
      documentoUsuario: '',
      novasNotificacoes: [],
      qtdNotificacoes: '',
      mensagens: [],
      menuOptions: [
        { name: 'Listagem de Editais', icon: 'fas fa-file', routeName: 'listagem-editais/listagem', params: '', routeGroup: ROUTE_GROUPS.LISTAGEM_EDITAIS },
        { name: 'Credenciados', icon: 'fas fa-user', routeName: 'credenciados/listagem', params: '', routeGroup: ROUTE_GROUPS.CREDENCIADOS },
      ],
      menuOptionsCredenciado: [
        { name: 'Solicitações', icon: 'far fa-sort-alt', routeName: 'credenciado/solicitacoes', params: '', routeGroup: ROUTE_GROUPS.SOLICITACOES },
        { name: 'Central de mensagens', icon: 'far fa-envelope', routeName: 'Mensagens', params: '', routeGroup: ROUTE_GROUPS.MENSAGENS },
      ]
    }
  },
  async created() {
    if (this.$route.name !== 'editais' && this.$route.name !== 'credenciados/cadastro') {
      const perfil = getUsuario()?.perfilSelecionado?.codigo;
      this.documentoUsuario = getUsuario()?.pessoa?.cpfCnpj;
      if (perfil === 'CREDENCIADOS') {
        this.perfilCredenciado = true;
      } else if (perfil === 'CAGEO' || perfil === 'CAVISTORIA') {
        this.perfilInterno = true;
        if (perfil === 'CAGEO') {
          this.menuOptions.push({ name: 'Possíveis credenciados', icon: 'fas fa-file-search', routeName: 'credenciados/credenciar', params: '', routeGroup: ROUTE_GROUPS.CREDENCIAR_PROCESSOS });
        }
      }
      this.countNotifications();
    }
  },
  computed: {
    ...mapState({
      loader: state => state.loader,
    }),
    showSideBar() {
      return this.$route.name !== 'credenciados/cadastro' && this.$route.name !== 'editais'
    }
  },
  methods: {
    goToMeusDados() {
      let location = process.env.VUE_APP_URL_MODULO_GESTAO_DADOS;
      if (process.env.NODE_ENV === 'development') {
        const token = getToken();
        location += `?token=${token}`;
      }
      window.location.href = location;
    },
    async countNotifications() {
      this.novasNotificacoes = [];
      const response = await listConversas(this.pagina = 0, this.tamanhoPagina = 999999);
      this.mensagens = response.content.reverse();

      for (const conversa of this.mensagens) {
        for (const m of conversa.mensagens) {
          if (m.remetente && m.status !== 'LIDA' && m.status !== 'RESPONDIDA' && m.remetente.cpfCnpj !== this.documentoUsuario) {
            this.novasNotificacoes.push(m);
          }
        }
      }
      this.qtdNotificacoes = this.novasNotificacoes.length.toString();
    },
    async sair () {
      logout()
    },
    async getUsuarioFromStorage () {
      this.usuario = getUsuario();
      if (!this.usuario) return;

      await this.loadUserProfilePicture();
    },

    async loadUserProfilePicture() {
      const response = await getProfilePicture();

      if (response && response.image) {
        this.$set(this.usuario, 'profilePicture', `data:image/png;base64,${response.image}`);
      }
    },
    notificacoes() {
      this.$router.push({path: '/credenciado/mensagens'});
    },
    toModelos() {
      this.$router.push({name: 'Modelos'});
    }
  },
  async mounted () {
    await this.getUsuarioFromStorage();
  }
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  font-family: 'Ubuntu', sans-serif;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.custom-header {
  padding: 0;
}
.main {
  padding: 60px;
  overflow-y: unset;
  max-height: 93vh;
  min-height: 93vh;
}
body {
  margin: 0px !important;
}
</style>
